import script from "./SocionicsCompatibility.vue?vue&type=script&setup=true&lang=js"
export * from "./SocionicsCompatibility.vue?vue&type=script&setup=true&lang=js"

import "./SocionicsCompatibility.vue?vue&type=style&index=0&id=2108f38c&scoped=true&lang=scss"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-2108f38c"]])

export default __exports__